import React, { useRef } from 'react';
import i18n from 'i18n-js';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import { createYupSchema } from 'utils/form';
import { Box, Button, Grid } from '@material-ui/core';
import { TextField } from 'components/FormFields';
import Loading from '../Loading';

const FormSchema = ({ schema, submitButtonLabel, loading, disabled }) => {
  const formRef = useRef(null);

  const yepSchema = schema?.properties?.reduce(createYupSchema, {});

  const renderField = (field) => {
    const { type } = field;
    switch (type) {
      case 'text':
        return (
          <Field
            type="text"
            name={field.name}
            label={field.label}
            component={TextField}
            placeholder={field.placeholder}
            required={field.required ?? false}
            inputProperties={field.inputProperties}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={schema.initialValues}
      validationSchema={Yup.object().shape(yepSchema)}
      onSubmit={(values, actions) => {
        schema.onSubmit(values, actions);
      }}
      validateOnMount={true}
      innerRef={formRef}
    >
      {({ touched, errors, setFieldValue, ...props }) => {
        return (
          <Form
            noValidate="novalidate"
            className={`${schema.className ? schema.className : ''}`}
            data-cy={schema.formName ? `form-submit-${schema.formName}` : 'form-submit'}
          >
            <Grid container spacing={2}>
              {schema?.properties?.map((field, i) => {
                return (
                  <Grid item xs={6} key={'container-' + field.name + i}>
                    {renderField({ ...props, ...field }, errors, touched, setFieldValue)}
                  </Grid>
                );
              })}
              <Grid item xs={12} container justifyContent="center">
                <Grid item xs={4}>
                  <Box mt={4}>
                    <Button
                      type="submit"
                      color="primary"
                      variant="contained"
                      size="large"
                      fullWidth
                      disabled={disabled || loading}
                    >
                      {loading ? <Loading /> : (submitButtonLabel ?? i18n.t('common.submit'))}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
};

FormSchema.propTypes = {
  schema: PropTypes.object.isRequired,
  submitButtonLabel: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default FormSchema;
